module.exports = __webpack_public_path__ + "media/images/h-coin-f219a2cc63bec8ebce43e08156341cb0.svg";